import React from 'react';
import featureImg from '../assets/features.jpg';
import {
  BeakerIcon,
  ClockIcon,
  CloudIcon,
  ShieldCheckIcon,
  CpuChipIcon,
  CircleStackIcon,
} from '@heroicons/react/24/outline';

const features = [
  {
    icon: BeakerIcon,
    text: 'Rapid detection of E. coli and coliform using Enzyme Substrate Method',
  },
  {
    icon: ClockIcon,
    text: 'Improved bacteria detection in 6 hrs',
  },
  {
    icon: CloudIcon,
    text: 'Remote control, real-time alerts, and cloud-based data analysis',
  },
  {
    icon: ShieldCheckIcon,
    text: 'LOD of 1 CFU in 12 hrs — meets WHO standards',
  },
  {
    icon: CpuChipIcon,
    text: 'Connectable to multiple sensors for multi-parameter monitoring',
  },
  {
    icon: CircleStackIcon,
    text: 'Supports large volume samples up to 1L',
  },
];

export default function Features() {
  return (
    <section id="features" className="scroll-mt-28 px-6 py-16 sm:py-20 bg-white" data-aos="fade-up">
      <div className="max-w-[1600px] mx-auto">
        <img src={featureImg} alt="Features" className="w-full rounded-2xl mb-10 shadow-lg" />

        <h2 className="text-3xl font-bold text-center text-teal-700 mb-10">Key Features</h2>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {features.map(({ icon: Icon, text }) => (
            <div
              key={text}
              className="flex items-start gap-4 bg-gray-50 rounded-2xl p-5 border border-gray-100 hover:shadow-md hover:-translate-y-0.5 transition-all duration-200"
            >
              <div className="shrink-0 bg-teal-100 text-teal-700 rounded-xl p-2.5">
                <Icon className="h-6 w-6" />
              </div>
              <p className="text-gray-700 text-sm leading-relaxed">{text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
